import { render } from "./qlc-hew.vue?vue&type=template&id=2bb16d42&scoped=true"
import script from "./qlc-hew.vue?vue&type=script&lang=js"
export * from "./qlc-hew.vue?vue&type=script&lang=js"

import "./qlc-hew.vue?vue&type=style&index=0&id=2bb16d42&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb16d42"]])

export default __exports__